import Button from "@components/global/new/Button/Button";
import Title from "@components/global/new/Title/Title";
import WithModal, { CommonModalPropsI } from "@components/HOC/withModals";
import { MODALS_ENUM } from "@constants/Modals";
import styles from "./DeleteMiner.module.scss";

interface DeleteMinerProps extends CommonModalPropsI {
  minerId: string;
  onDelete(): void;
}

function DeleteMiner({
  minerId,
  onDelete,
  formatMessage,
  ...props
}: DeleteMinerProps) {
  return (
    <div className={styles.wrapper}>
      <Title>
        {formatMessage({ id: "modal.delete_miner.title" }, { miner: minerId })}
      </Title>
      <div className={styles.content}>
        <p>{formatMessage({ id: "modal.delete_miner.sure" })}</p>
        <div className={styles.btn_wrapper}>
          <Button white onClick={props.handleClose}>
            {formatMessage({ id: "modal.delete_miner.btn.cancel" })}
          </Button>
          <Button
            onClick={() => {
              onDelete();
              props.handleClose();
            }}
          >
            {formatMessage({ id: "modal.delete_miner.btn.continue" })}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default WithModal(MODALS_ENUM.DELETE_MINER, DeleteMiner);
